export enum RecorderType {
  Desktop = 'desktop',
  Web = 'web',
}

/**
 * Capture type is used to determine how the scribe was created.
 */
export enum CaptureType {
  /**
   * The scribe was created using the extension's AutoCapture (long-running recorder) feature.
   */
  ExtensionAutoCapture = 'extension_auto_capture',
  /**
   * The scribe was created using the extension's normal capture method.
   */
  ManualCapture = 'manual_capture',
}
